import {
  type AccessKeyImport,
  type CreateAccessKeyImportRequest,
} from '~/common/types/accessKeys/accessKeyImport';
import config from '@/config/config';
import createRestClient from '../restClient';

const client = createRestClient(config.baseURL);

const createAccessKeyImport = ({
  data,
  onProgress,
}: {
  data: CreateAccessKeyImportRequest;
  onProgress: CallableFunction;
}) =>
  client.postForm('/accessKeys/accessKeyImport', data, {
    onUploadProgress: (progressEvent) => {
      if (progressEvent && progressEvent.loaded && progressEvent.total) {
        const progress = (progressEvent.loaded / progressEvent.total) * 100;

        onProgress(Math.round(progress));
      }
    },
  }) as Promise<AccessKeyImport>;

export default {
  createAccessKeyImport,
};
